import { PortableTextTypeComponentProps } from "@portabletext/react";
import { Body, Caption, Container } from "./styles";

export type ArticleQuoteProps = PortableTextTypeComponentProps<{
  body: string;
  caption?: string;
}>;

const ArticleQuote: React.FC<ArticleQuoteProps> = (props) => {
  const { caption, body } = props.value;
  return (
    <Container>
      <Body>{body}</Body>
      {caption && <Caption>{caption}</Caption>}
    </Container>
  );
};

export default ArticleQuote;
